<template>
    <v-tooltip :color="color" top>
        <template #activator="{ on }">
            <v-icon v-if="get(report, `${event}.${verification}`)" color="green" v-on="on"> check </v-icon>
            <v-icon v-else-if="has(report, event)" color="grey lighten-2" v-on="on"> mdi-close </v-icon>
        </template>
        <strong>{{ formattedScore(`${event}.result.prelims_score`) }}</strong> Score
        <br />
        <strong>{{ formattedScore(`${event}.${verificationMark}`) }}</strong> <slot>Qualification Score</slot>
    </v-tooltip>
</template>

<script>
import numeral from 'numeral';
import get from 'lodash/get.js';
import has from 'lodash/has.js';

export default {
    name: 'QualifierCheck',

    props: {
        report: {
            type: Object,
            required: true,
        },

        color: {
            type: String,
            required: true,
        },

        event: {
            type: String,
            required: true,
        },

        verification: {
            type: String,
            required: true,
        },

        verificationMark: {
            type: String,
            required: true,
        },
    },

    data: () => ({}),

    methods: {
        get,
        has,

        formattedScore(field) {
            const score = get(this.report, field);

            if (!score) {
                return 'N/A';
            }

            return numeral(score).format('0.000');
        },
    },
};
</script>
